import { render } from "./customColor.vue?vue&type=template&id=1912787a"
import script from "./customColor.vue?vue&type=script&lang=js"
export * from "./customColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__